<template>
  <div>

    <!--header-->
    <div class="header">
      <div class="bg_header">
        <div class="header_nav fl t_title">
          梅捷 固蓄节能供暖机组运维大数据中心
        </div>
      </div>
    </div>

    <!--main-->
    <div class="data_content">
      <div class="data_main">
        <div class="main_left fl">
          <div class="left_1 t_btn6">
            <!--左上边框-->
            <div class="t_line_box">
              <i class="t_l_line"></i>
              <i class="l_t_line"></i>
            </div>
            <!--右上边框-->
            <div class="t_line_box">
              <i class="t_r_line"></i>
              <i class="r_t_line"></i>
            </div>
            <!--左下边框-->
            <div class="t_line_box">
              <i class="l_b_line"></i>
              <i class="b_l_line"></i>
            </div>
            <!--右下边框-->
            <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div>
            <div class="main_title" @click="toggleCenter('left_1_chart','年装机数量',queryDevices)">
              <img src="img/设备数.svg" alt="" style="width: 18px;height: 18px">
              年装机数量
            </div>
            <div id="left_1_chart" class="left_1_content"></div>
          </div>
          <div class="left_2">
            <!--左上边框-->
            <div class="t_line_box">
              <i class="t_l_line"></i>
              <i class="l_t_line"></i>
            </div>
            <!--右上边框-->
            <div class="t_line_box">
              <i class="t_r_line"></i>
              <i class="r_t_line"></i>
            </div>
            <!--左下边框-->
            <div class="t_line_box">
              <i class="l_b_line"></i>
              <i class="b_l_line"></i>
            </div>
            <!--右下边框-->
            <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div>
            <div class="main_title" @click="toggleCenter('left_2_chart','总装机功率',queryPowers)">
              <img src="img/装机功率.svg" alt="" style="width: 18px;height: 18px">
              总装机功率
            </div>
            <div id="left_2_chart" class="left_2_content"></div>
          </div>
          <div class="left_3">
            <!--左上边框-->
            <div class="t_line_box">
              <i class="t_l_line"></i>
              <i class="l_t_line"></i>
            </div>
            <!--右上边框-->
            <div class="t_line_box">
              <i class="t_r_line"></i>
              <i class="r_t_line"></i>
            </div>
            <!--左下边框-->
            <div class="t_line_box">
              <i class="l_b_line"></i>
              <i class="b_l_line"></i>
            </div>
            <!--右下边框-->
            <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div>
            <div class="main_title" @click="toggleCenter('left_3_chart','总蓄能功率',querySupplierInfoSummary)">
              <img src="img/累计储能.svg" alt="" style="width: 18px;height: 18px">
              总蓄能功率
            </div>
            <div id="left_3_chart" class="left_3_content"></div>
          </div>
          <div class="left_4">
            <!--左上边框-->
            <div class="t_line_box">
              <i class="t_l_line"></i>
              <i class="l_t_line"></i>
            </div>
            <!--右上边框-->
            <div class="t_line_box">
              <i class="t_r_line"></i>
              <i class="r_t_line"></i>
            </div>
            <!--左下边框-->
            <div class="t_line_box">
              <i class="l_b_line"></i>
              <i class="b_l_line"></i>
            </div>
            <!--右下边框-->
            <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div>
            <div class="main_title" @click="toggleCenter('left_4_chart','地区室外温度',queryOutdoor)">
              <img src="img/温度.svg" alt="" style="width: 18px;height: 18px">
              地区室外温度
            </div>
            <div id="left_4_chart" class="left_4_content"></div>
          </div>
        </div>
        <div class="main_center fl">
          <div class="center_1">
            <Map ref="map" v-if="currentCenterId==null"></Map>
            <div v-else :id="`${currentCenterId}-temp`" style="width: 100%" :style="{height:`${mapHeight}px`}"></div>
          </div>
          <div class="center_2">
            <!--左上边框-->
            <div class="t_line_box">
              <i class="t_l_line"></i>
              <i class="l_t_line"></i>
            </div>
            <!--右上边框-->
            <div class="t_line_box">
              <i class="t_r_line"></i>
              <i class="r_t_line"></i>
            </div>
            <!--左下边框-->
            <div class="t_line_box">
              <i class="l_b_line"></i>
              <i class="b_l_line"></i>
            </div>
            <!--右下边框-->
            <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div>
            <div class="main_title">
              <img src="img/t_5.png" alt="">
              节能减排数据监控
            </div>
            <div class="center_2_content">
              <div v-for="(item,index) in totalSummaryProps" :key="index" style="display: flex;flex-direction: column">
                <div class="center_2_title_item">{{ item }}</div>
                <div class="center_2_data_item">{{ totalSummary[item] }}</div>
              </div>
            </div>
          </div>

          <div class="center_3">
            <!--左上边框-->
            <div class="t_line_box">
              <i class="t_l_line"></i>
              <i class="l_t_line"></i>
            </div>
            <!--右上边框-->
            <div class="t_line_box">
              <i class="t_r_line"></i>
              <i class="r_t_line"></i>
            </div>
            <!--左下边框-->
            <div class="t_line_box">
              <i class="l_b_line"></i>
              <i class="b_l_line"></i>
            </div>
            <!--右下边框-->
            <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div>
            <div class="main_title">
              <img src="img/t_7.png" alt="">
              全国电网峰谷电价
            </div>
            <div class="center_3_content">
              <div id="center_3_table" class="main_table t_btn8">
                <table>
                  <thead>
                  <tr>
                    <th>电网区域</th>
                    <th>装机数量</th>
                    <th>在线数量</th>
                    <th>装机总功率</th>
                    <th>峰谷电价时间</th>
                    <th>电价</th>
                    <th>峰谷年运行总功率</th>
                    <th>累计运行总功率</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="`table-1-${index}`" v-for="(item,index) in data['全国电网峰谷电价']">
                    <td>{{ item['电网区域'] }}</td>
                    <td>{{ item['装机数量'] }}</td>
                    <td>{{ item['在线数量'] }}</td>
                    <td>{{ item['装机总功率'] }}</td>
                    <td>{{ item['峰谷电价时间'] }}</td>
                    <td>{{ item['电价'] }}</td>
                    <td>{{ item['峰谷年运行总功率'] }}</td>
                    <td>{{ item['累计运行总功率'] }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="main_right fr">
          <div class="right_1">
            <!--左上边框-->
            <div class="t_line_box">
              <i class="t_l_line"></i>
              <i class="l_t_line"></i>
            </div>
            <!--右上边框-->
            <div class="t_line_box">
              <i class="t_r_line"></i>
              <i class="r_t_line"></i>
            </div>
            <!--左下边框-->
            <div class="t_line_box">
              <i class="l_b_line"></i>
              <i class="b_l_line"></i>
            </div>
            <!--右下边框-->
            <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div>
            <div class="main_title">
              <img src="img/t_4.png" alt="">
              设备运行信息
            </div>
            <div class="right_1_content">
              <div id="right_1_table" class="main_table t_btn8">
                <table>
                  <thead>
                  <tr>
                    <th v-for="(item,index) in runningInfoProps" :key="index">{{ item }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="index" v-for="(item,index) in runningInfo">
                    <td v-for="(item1,index1) in runningInfoProps" :key="index1">{{ item[item1] }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="right_2">
            <!--左上边框-->
            <div class="t_line_box">
              <i class="t_l_line"></i>
              <i class="l_t_line"></i>
            </div>
            <!--右上边框-->
            <div class="t_line_box">
              <i class="t_r_line"></i>
              <i class="r_t_line"></i>
            </div>
            <!--左下边框-->
            <div class="t_line_box">
              <i class="l_b_line"></i>
              <i class="b_l_line"></i>
            </div>
            <!--右下边框-->
            <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div>
            <div class="main_title" @click="toggleCenter('right_2_chart','全国装机比例',queryDeviceRatio)">
              <img src="img/t_3.png" alt="">
              全国装机比例
            </div>
            <div id="right_2_chart" class="right_2_content"></div>
          </div>
          <div class="right_3">
            <!--左上边框-->
            <div class="t_line_box">
              <i class="t_l_line"></i>
              <i class="l_t_line"></i>
            </div>
            <!--右上边框-->
            <div class="t_line_box">
              <i class="t_r_line"></i>
              <i class="r_t_line"></i>
            </div>
            <!--左下边框-->
            <div class="t_line_box">
              <i class="l_b_line"></i>
              <i class="b_l_line"></i>
            </div>
            <!--右下边框-->
            <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div>
            <div class="main_title" @click="toggleCenter('right_3_chart','设备节能减排曲线',queryTotalMonthSummary)">
              <img src="img/t_5.png" alt="">
              设备节能减排曲线
            </div>
            <div id="right_3_chart" class="right_3_content"></div>
          </div>
          <div class="right_4">
            <!--左上边框-->
            <div class="t_line_box">
              <i class="t_l_line"></i>
              <i class="l_t_line"></i>
            </div>
            <!--右上边框-->
            <div class="t_line_box">
              <i class="t_r_line"></i>
              <i class="r_t_line"></i>
            </div>
            <!--左下边框-->
            <div class="t_line_box">
              <i class="l_b_line"></i>
              <i class="b_l_line"></i>
            </div>
            <!--右下边框-->
            <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div>
            <div class="main_title" @click="toggleCenter('right_4_chart','供暖面积分析',queryHeatingAreaSummary)">
              <img src="img/供暖总面积.svg" alt="" style="width: 18px;height: 18px">
              供暖面积分析
            </div>
            <div id="right_4_chart" class="right_4_content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Map from '@/components/Map'

import axios from 'axios'
import { fetch } from '@/utils/backend'
import moment from 'moment'

const options = {
  backgroundColor: '',
  grid: {
    left: '3%',
    right: '4%',
    top: '20%',
    bottom: '3%',
    containLabel: true
  }
}

export default {
  name: 'App',
  components: { Map },
  data: function () {
    return {
      data: {
        '年装机数量': {},
        '总装机功率': {},
        '总蓄能功率': {},
        '地区室外温度': {},
        '节能减排数据监控': {},
        '全国电网峰谷电价': [],
        '设备运行信息': [],
        '全国装机比例': {},
        '设备节能减排曲线': {},
        '区域电网电价': {},
      },
      totalSummary: {},
      totalSummaryProps: [],
      runningInfo: [],
      runningInfoProps: [],
      interval: null,
      currentCenterId: null,
      mapHeight: ''
    }
  },
  created() {
    this.queryDevices('left_1_chart')
    this.queryPowers('left_2_chart')
    this.querySupplierInfoSummary('left_3_chart')
    this.queryOutdoor('left_4_chart')
    this.queryTotalSummary()
    this.queryDeviceRunningInfo()
    this.queryDeviceRatio('right_2_chart')
    this.queryTotalMonthSummary('right_3_chart')
    this.queryHeatingAreaSummary('right_4_chart')
    this.interval = setInterval(() => {
      this.queryDeviceRunningInfo()
    }, 5000)
    this.import()
  },
  mounted() {
    this.resizeTable()
    this.mapHeight = this.$refs.map.$el.clientHeight
  },
  beforeDestroy() {
    this.interval && clearInterval(this.interval)
  },
  methods: {
    querySummary(path, callback, params) {
      fetch(path, params).then(({ data }) => {
        callback && callback(data)
      })
    },
    queryDevices(id, title) {
      const type = 'year'
      this.querySummary(`${type}_devices`, (data) => {
        const legend = []
        for (const item in data[0]) {
          if (item === 'year' || item === 'month') {
            continue
          }
          legend.push(item)
        }
        this.renderChart(id, {
          ...options,
          title: {
            text: title,
            right: 0
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            selected: {
              // '功率': false
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: data.map(item => type === 'year' ? item.year : `${item.year}-${item.month}`)
          },
          yAxis: {
            type: 'value'
          },
          series: legend.map(prop => {
            return {
              name: prop,
              type: 'bar',
              data: data.map(item => item[prop]),
              smooth: true,
              markPoint: {
                data: [
                  { type: 'max', name: '最大值' },
                  { type: 'min', name: '最小值' }
                ]
              },
              markLine: {
                data: [
                  { type: 'average', name: '平均值' }
                ]
              }
            }
          })
        })
      })
    },
    queryPowers(id, title) {
      this.querySummary('district_devices', (data) => {
        console.log('district_devices', data)

        const legend = []
        for (const item in data[0]) {
          if (item === 'district' || item === 'center') {
            continue
          }
          legend.push(item)
        }
        this.renderChart(id, {
          ...options,
          title: {
            text: title,
            right: 0
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            selected: {
              '功率': false
            }
          },
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
          },
          yAxis: {
            type: 'category',
            data: data.map(item => item.district)
          },
          series: legend.map(prop => {
            return {
              name: prop,
              type: 'bar',
              data: data.map(item => item[prop])
            }
          })
        })

      }, { level: 0 })
    },
    querySupplierInfoSummary(id, title) {
      const type = 'year'
      const params = {}
      if (type === 'year') {
        params.year = moment().year()
      }
      this.querySummary(`supplier_${type}_device_info_summary`, (data) => {
        const legend = []
        const selected = {}
        for (const item in data[0]) {
          if (item === 'supplierName') {
            continue
          }
          if (item !== '累计储能') {
            continue
          }
          legend.push(item)
          if (item !== '累计储能') {
            selected[item] = false
          }
        }
        this.renderChart(id, {
          ...options,
          title: {
            text: title,
            right: 0
          },
          tooltip: {
            trigger: 'axis'
          },
          // legend: {
          //   selected
          // },
          xAxis: {
            type: 'category',
            boundaryGap: [0, 0.01],
            data: data.map(item => item.supplierName.substring(0, 4))
          },
          yAxis: {
            type: 'value'
          },
          series: legend.map(prop => {
            return {
              name: prop,
              type: 'bar',
              data: data.map(item => item[prop]),
              smooth: true
            }
          })
        })

      }, params)
    },
    queryOutdoor(id, title) {
      this.querySummary('outdoor', (data) => {
        const legend = []
        for (const item in data[0]) {
          if (item === 'district') {
            continue
          }
          legend.push(item)
        }
        this.renderChart(id, {
          ...options,
          title: {
            text: title,
            right: 0
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          // legend:{},
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
          },
          yAxis: {
            type: 'category',
            data: data.map(item => item.district)
          },
          series: legend.map(prop => {
            return {
              name: prop,
              type: 'bar',
              data: data.map(item => item[prop])
            }
          })
        })

      }, { level: 0 })
    },
    queryTotalSummary() {
      const that = this
      this.querySummary(`total_summary`, (data) => {
        for (const item in data[0]) {
          const prop = item.substring(0, item.indexOf('（'))
          that.totalSummaryProps.push(prop)
          that.totalSummary[prop] = data[0][item] + item.substring(item.indexOf('（')).replace('（', '').replace('）', '')
        }
      })
    },
    queryDeviceRunningInfo() {
      const that = this
      this.querySummary(`running_info`, (data) => {
        that.runningInfoProps = []
        that.runningInfo = data.map(item => {
          let code = item['设备编号'] || '未知'
          if (code.length > 8) {
            code = code.substring(0, 8) + '...'
          }
          return { ...item, '设备编号': code, '地区': item['地区'].split(',')[0] }
        })
        for (const item in data[0]) {
          that.runningInfoProps.push(item)
        }
      })
    },
    queryDeviceRatio(id, title) {
      this.querySummary('district_devices', (data) => {
        this.renderChart(id, {
          ...options,
          title: {
            text: title,
            right: 0
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'left'
          },
          series: [
            {
              name: '数量',
              type: 'pie',
              radius: '50%',
              data: data.map(item => {
                return { value: item['数量'], name: item.district }
              }),
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ],
        })
      }, { level: 0 })
    },
    queryTotalMonthSummary(id, title) {
      const that = this
      this.querySummary(`total_month_summary`, (data) => {
        const legend = []
        for (const item in data[0]) {
          if (item === 'month') {
            continue
          }
          legend.push(item)
        }
        this.renderChart(id, {
          ...options,
          title: {
            text: title,
            right: 0
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {},
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: data.map(item => item.month)
          },
          yAxis: {
            type: 'value'
          },
          series: legend.map(prop => {
            return {
              name: prop,
              type: 'line',
              data: data.map(item => item[prop]),
              smooth: true
            }
          })
        })
      })
    },
    queryHeatingAreaSummary(id, title) {
      this.querySummary('heating_area_summary', (data) => {
        this.renderChart(id, {
          ...options,
          title: {
            text: title,
            right: 0
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left'
          },
          series: [
            {
              name: '面积',
              type: 'pie',
              radius: '50%',
              data: data.map(item => {
                return { value: item['供暖面积'], name: item.groupName }
              }),
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        })

      })
    },
    renderChart(id, options) {
      const chart = echarts.init(document.getElementById(id), 'dark')
      chart.setOption(options)
      window.addEventListener('resize', function () {
        chart.resize()
      })
    },
    resizeTable() {
      $('.left_1, .left_2, .left_3, .left_4').height(($('body').height() - $('.header').height() - 110) / 4)
      $('.right_1, .right_2, .right_3, .right_4').height(($('body').height() - $('.header').height() - 100) / 4)
      $('#right_1_table tr').height(($('.right_1').height() - 75) / 4)
      $('#map-container').height($('.center_1').height())
      $('.center_3').height($('body').height() - $('.header').height() - $('.center_1').height() - $('.center_2').height() - 85)
      $('#center_3_table tr').height(($('.center_3').height() - 50) / 5)
    },
    import() {
      const that = this
      axios.get('/resource/data.json?v=1').then(({ data: data }) => {
        console.log(data)
        that.data = data
        that.render(data)
      })
    },
    render(data) {
      // echart_left_1(data['年装机数量'])
      // echart_left_2(data['总装机功率'])
      // echart_left_3(data['总蓄能功率'])
      // echart_left_4(data['地区室外温度'])
      // echart_right_2(data['全国装机比例'])
      // echart_right_3(data['设备节能减排曲线'])
      // echart_right_4(data['区域电网电价'])

      function echart_left_1(data) {
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('left_1_chart'), 'dark')
        const option = {
          backgroundColor: '',
          title: {
            text: '',
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: data['分类']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          // toolbox: {
          //     show: true,
          //     feature: {
          //         dataView: {show: true, readOnly: false},
          //         magicType: {show: true, type: ['line', 'bar']},
          //         restore: {show: true},
          //         saveAsImage: {show: true}
          //     }
          // },
          calculable: true,
          xAxis: [
            {
              type: 'category',
              data: data['横轴']
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '装机功率',
              type: 'bar',
              data: data['装机功率'],
              markPoint: {
                data: [
                  { type: 'max', name: '最大值' },
                  { type: 'min', name: '最小值' }
                ]
              },
              // markLine: {
              //     data: [
              //         {type: 'average', name: '平均值'}
              //     ]
              // }
            },
            {
              name: '装机数量',
              type: 'bar',
              data: data['装机数量'],
              markPoint: {
                data: [
                  { type: 'max', name: '最大值' },
                  { type: 'min', name: '最小值' }
                ]
              },
              // markLine: {
              //     data: [
              //         {type: 'average', name: '平均值'}
              //     ]
              // }
            }
          ]
        }

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option)
        window.addEventListener('resize', function () {
          myChart.resize()
        })
      }

      function echart_left_2(data) {
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('left_2_chart'), 'dark')
        const option = {
          backgroundColor: '',
          title: {
            text: '',
          },
          legend: {
            data: ['总装机功率']
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
          },
          yAxis: {
            type: 'category',
            data: data['纵轴']
          },
          series: [
            {
              name: '总装机功率',
              type: 'bar',
              data: data['取值']
            },
          ]
        }

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option)
        window.addEventListener('resize', function () {
          myChart.resize()
        })
      }

      function echart_left_3(data) {
        const series = []
        data['分类'].forEach((item, index) => {
          if (data[item]) {
            series.push({
              name: item,
              type: 'line',
              smooth: true,
              // areaStyle: {},
              data: data[item]
            })
          }
        })
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('left_3_chart'), 'dark')
        const option = {
          backgroundColor: '',
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            data: data['分类']
          },
          toolbox: {
            show: true,
            feature: {
              magicType: { show: true, type: ['stack', 'tiled'] },
              saveAsImage: { show: true }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: data['横轴']
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: series
        }

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option)
        window.addEventListener('resize', function () {
          myChart.resize()
        })
      }

      function echart_left_4(data) {
        const series = []
        data['分类'].forEach((item, index) => {
          if (data[item]) {
            series.push({
              name: item,
              type: 'line',
              // smooth: true,
              // areaStyle: {},
              data: data[item]
            })
          }
        })
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('left_4_chart'), 'dark')
        const option = {
          backgroundColor: '',
          title: {
            text: ''
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: data['分类']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            show: true,
            feature: {
              magicType: { show: true, type: ['stack', 'tiled'] },
              saveAsImage: { show: true }
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: data['横轴']
          },
          yAxis: {
            type: 'value'
          },
          series: series
        }

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option)
        window.addEventListener('resize', function () {
          myChart.resize()
        })
      }

      function echart_right_2(data) {
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('right_2_chart'), 'dark')
        const option = {
          backgroundColor: '',
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          series: [
            {
              name: '设备数',
              type: 'pie',
              radius: '55%',
              center: ['50%', '60%'],
              data: data['数据'],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option)
        window.addEventListener('resize', function () {
          myChart.resize()
        })
      }

      function echart_right_3(data) {
        const series = []
        data['分类'].forEach((item, index) => {
          if (data[item]) {
            series.push({
              name: item,
              type: 'line',
              data: data[item]
            })
          }
        })
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('right_3_chart'), 'dark')
        const option = {
          backgroundColor: '',
          legend: {
            data: data['分类']
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            show: true,
            feature: {
              magicType: { show: true, type: ['stack', 'tiled'] },
              saveAsImage: { show: true }
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: data['横轴']
          },
          yAxis: {
            type: 'value'
          },
          series: series
        }

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option)
        window.addEventListener('resize', function () {
          myChart.resize()
        })
      }

      function echart_right_4(data) {
        const series = []
        data['分类'].forEach((item, index) => {
          if (data[item]) {
            series.push({
              name: item,
              type: 'line',
              data: data[item]
            })
          }
        })
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('right_4_chart'), 'dark')
        const option = {
          backgroundColor: '',
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            data: data['分类']
          },
          toolbox: {
            show: true,
            feature: {
              magicType: { show: true, type: ['stack', 'tiled'] },
              saveAsImage: { show: true }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: data['横轴']
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: series
        }

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option)
        window.addEventListener('resize', function () {
          myChart.resize()
        })
      }

      const that = this
      this.resizeTable()
      window.addEventListener('resize', function () {
        that.resizeTable()
      })
    },
    toggleCenter(id, title, func) {
      if (this.currentCenterId != null && this.currentCenterId === id) {
        this.currentCenterId = null
        this.$nextTick(() => {
          this.$refs.map.getData()
        })
      } else {
        this.currentCenterId = id
        this.$nextTick(() => {
          func(`${id}-temp`, title)
        })
      }
    }
  }
}
</script>

<style>
/*#app {*/
/*  font-family: Avenir, Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
/*  text-align: center;*/
/*  color: #2c3e50;*/
/*  margin-top: 60px;*/
/*}*/
</style>
